import React from 'react';

const AddToggle = React.forwardRef(({ children, onClick }, ref) => {
  return (
    <a
      href=""
      ref={ref}
      className="add-tab-toggle"
      onClick={e => {
        e.preventDefault();
        onClick(e);
      }}
    >
      {children}
    </a>
  );
});

export default AddToggle;

